import { singleton, container } from 'tsyringe';
import { AppCheck, getLimitedUseToken, getToken, initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

import { FirebaseAppInstance } from './firebase-app';
import { useConfig } from '@/composables';
const config = useConfig();

@singleton()
export class FirebaseAppCheck {
  appCheck: AppCheck | undefined;

  constructor() {
    const firebaseApp = container.resolve(FirebaseAppInstance).app;
    const recaptchaConfig = config.value.recaptcha;

    if (!recaptchaConfig?.enabled) {
      return;
    }

    const siteKey = recaptchaConfig.siteKey;

    if (firebaseApp && siteKey) {
      this.appCheck = initializeAppCheck(firebaseApp, {
        provider: new ReCaptchaEnterpriseProvider(siteKey),
        isTokenAutoRefreshEnabled: true,
      });
    }
  }

  /**
   * Retrieves a Firebase App Check token.
   * @param forceRefresh - Whether to force refresh the token (server request)
   * @returns
   */
  async getToken(forceRefresh?: boolean): Promise<string | undefined> {
    if (!this.appCheck) {
      return;
    }

    try {
      return (await getToken(this.appCheck, forceRefresh)).token;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.debug('Error getting App Check token:', error);
    }
  }

  /**
   * This retrieves a limited use App Check token which can be consumed on the server, thus
   * preventing replays.
   * @see - https://firebase.google.com/docs/reference/js/app-check.md#getlimitedusetoken_53ef5e3
   */
  async getLimitedToken(): Promise<string | undefined> {
    if (!this.appCheck) {
      return;
    }

    try {
      return (await getLimitedUseToken(this.appCheck)).token;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.debug('Error getting Limited use App Check token:', error);
    }
  }
}
